module.exports = __webpack_public_path__ + "img/HZ-B5777.25cce189.jpg";